export default __webpack_public_path__ + "static/media/IMG_20190722_141439.48626b20.jpg";